function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0nf{fill:#F0F0F0;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0nf",
  d: "M41.43,11.53h-2.51V7.01c0-1.09-0.88-1.97-1.97-1.97H19.11L15.5,0H1.97C0.88,0,0,0.88,0,1.97v31.48h0 c0,0.41,0.12,0.8,0.38,1.13c0.35,0.46,0.89,0.72,1.47,0.72H34.1c0.83,0,1.57-0.56,1.77-1.31l7.37-20.2v-0.13 C43.23,12.43,42.47,11.53,41.43,11.53z M1.44,1.97c0-0.29,0.24-0.53,0.53-0.53h12.79l3.6,5.04h18.58c0.29,0,0.53,0.24,0.53,0.53 v4.52H9.17c-0.1,0-0.21,0.01-0.31,0.03c-0.7,0.12-1.28,0.63-1.46,1.28L1.44,29.11V1.97z M34.49,33.57c-0.05,0.18-0.21,0.3-0.39,0.3 H1.85c-0.18,0-0.28-0.1-0.32-0.16c-0.05-0.06-0.12-0.18-0.09-0.29l7.34-20.14c0.05-0.18,0.21-0.3,0.39-0.3h29.74h2.51 c0.27,0,0.34,0.39,0.36,0.59L34.49,33.57z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 20.53,
  y: 16.38,
  className: "st0nf",
  width: 2.18,
  height: 15.26
}), /*#__PURE__*/React.createElement("rect", {
  x: 20.53,
  y: 16.38,
  transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 45.6294 2.3949)",
  className: "st0nf",
  width: 2.18,
  height: 15.26
})));

var SvgMenuNewFolder = function SvgMenuNewFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.23 35.31",
    style: {
      enableBackground: "new 0 0 43.23 35.31"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuNewFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu_NewFolder.944c6bc5.svg";
export { ForwardRef as ReactComponent };